<template>
  <div class="register-page">
    <NavBar active-page="register" />
    
    <div class="content">
      <div class="form-container">
        <h2 class="form-title">用户注册</h2>
        
        <div class="alert error" v-if="error">{{ error }}</div>
        <div class="alert success" v-if="success">{{ success }}</div>
        
        <form @submit.prevent="handleRegister">
          <div class="form-group">
            <label for="username">用户名</label>
            <input 
              type="text" 
              id="username" 
              v-model="username" 
              placeholder="请输入用户名"
              required
            />
          </div>
          
          <div class="form-group">
            <label for="password">密码</label>
            <input 
              type="password" 
              id="password" 
              v-model="password" 
              placeholder="请输入密码"
              required
            />
          </div>
          
          <div class="form-group">
            <label for="confirmPassword">确认密码</label>
            <input 
              type="password" 
              id="confirmPassword" 
              v-model="confirmPassword" 
              placeholder="请再次输入密码"
              required
            />
          </div>
          
          <button type="submit" class="submit-button" :disabled="loading">
            {{ loading ? '注册中...' : '注册' }}
          </button>
        </form>
        
        <div class="form-footer">
          <p>已有账号？ <span class="link" @click="navigateToLogin">立即登录</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'RegisterPage',
  components: {
    NavBar
  },
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      loading: false,
      error: '',
      success: ''
    }
  },
  methods: {
    async handleRegister() {
      this.loading = true;
      this.error = '';
      this.success = '';
      
      // 验证密码
      if (this.password !== this.confirmPassword) {
        this.error = '两次输入的密码不一致';
        this.loading = false;
        return;
      }
      
      try {
        console.log('开始注册请求...');
        // 使用store的register action
        const result = await this.$store.dispatch('register', {
          username: this.username,
          password: this.password
        });
        
        console.log('注册请求结果:', result);
        
        if (result) {
          this.success = '注册成功！';
          
          // 重定向到听课页面
          console.log('准备跳转到听页面...');
          setTimeout(() => {
            console.log('执行跳转到听页面...');
            this.navigateToListen();
          }, 1000);
        } else {
          this.error = '注册失败，请重试';
        }
      } catch (error) {
        console.error('注册请求出错:', error);
        if (error.response && error.response.data) {
          this.error = error.response.data.message || '注册失败，请重试';
        } else {
          this.error = '注册失败，请稍后重试';
        }
      } finally {
        this.loading = false;
      }
    },
    navigateToListen() {
      console.log('正在导航到Listen页面...');
      this.$router.push('/listen');
    },
    navigateToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
.register-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.content {
  flex: 1;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-container {
  max-width: 400px;
  width: 100%;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.form-title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-button {
  width: 100%;
  padding: 12px 16px;
  background-color: #2c3e50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #1a2530;
}

.submit-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.form-footer {
  margin-top: 20px;
  text-align: center;
}

.link {
  color: #2c3e50;
  font-weight: 500;
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.alert {
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.alert.error {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}

.alert.success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}
</style> 